module.exports = __webpack_public_path__ + "static/img/specialist-bg.7a3fa59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/specialist-bg.jpg
// module id = vYPj
// module chunks = 7